import { render } from "./AccountNotActivatedV2.vue?vue&type=template&id=3ba10262"
import script from "./AccountNotActivatedV2.vue?vue&type=script&lang=js"
export * from "./AccountNotActivatedV2.vue?vue&type=script&lang=js"

import "./AccountNotActivatedV2.vue?vue&type=style&index=0&id=3ba10262&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__